import React, {
  Component
} from 'react';
import {
  Link
} from 'react-router';
import {
  connect
} from 'react-redux';
import {
  bindActionCreators
} from 'redux';
import {
  changeColor,
  clearDraw
} from '../../../actions/ts_overlay_actions.js';
import {
  updateModal
} from '../../../actions/modal.js';
import {
  updateCanvas
} from '../../../actions/ts_canvas_actions.js';
import {
  changeStamp
} from '../../../actions/ts_stamp_actions.js';
import {
  Button,
  Modal,
  Grid,
  Row,
  Col,
  Clearfix,
  ButtonToolbar,
  DropdownButton,
  MenuItem,
  ButtonGroup,
  Dropdown,
  Accordion,
  Panel,
  PanelGroup
} from 'react-bootstrap';
var Numbers = React.createClass({
  stampSelected(stamp) {
    var {
      dispatch,
      overlay
    } = this.props;
    dispatch(clearDraw(overlay.color, overlay.color1, overlay.color2));
    dispatch(changeStamp(stamp, 'white'));
    dispatch(updateModal(false, null));
  },


  render() {
    var {
      overlay,
      map,
      currentUser
    } = this.props;
    var cellStyle= "fa-lg pointerCursor";
    if(overlay.color == 'blue'){
      cellStyle ="fa-lg icon-blue pointerCursor";
    }
    if(overlay.color == 'red'){
        cellStyle ="fa-lg icon-red pointerCursor";
    }
    return (
      <div>
        <Grid>
        <Row>
        <Col md={1} xs={2} onClick={(event) => {this.stampSelected('1');}} className={cellStyle} >1</Col>
        <Col md={1} xs={2} onClick={(event) => {this.stampSelected('2');}} className={cellStyle} >2</Col>
        <Col md={1} xs={2} onClick={(event) => {this.stampSelected('3');}} className={cellStyle} >3</Col>
        <Col md={1} xs={2} onClick={(event) => {this.stampSelected('4');}} className={cellStyle} >4</Col>
        <Col md={1} xs={2} onClick={(event) => {this.stampSelected('5');}} className={cellStyle} >5</Col>
        <Col md={1} xs={2} onClick={(event) => {this.stampSelected('6');}} className={cellStyle} >6</Col>
        </Row>
        <Row>
        <Col md={1} xs={2}><br/></Col>
        </Row>
        <Row>
        <Col md={1} xs={2} onClick={(event) => {this.stampSelected('7');}} className={cellStyle} >7</Col>
        <Col md={1} xs={2} onClick={(event) => {this.stampSelected('8');}} className={cellStyle} >8</Col>
        <Col md={1} xs={2} onClick={(event) => {this.stampSelected('9');}} className={cellStyle} >9</Col>
        <Col md={1} xs={2} onClick={(event) => {this.stampSelected('0');}} className={cellStyle} >0</Col>
        <Col md={1} xs={2} onClick={(event) => {this.stampSelected('\u2460');}} className={cellStyle} >&#9312;</Col>
        <Col md={1} xs={2} onClick={(event) => {this.stampSelected('\u2461');}} className={cellStyle} >&#9313;</Col>
        </Row>
        <Row>
        <Col md={1} xs={2}><br/></Col>
        </Row>
        <Row>
          <Col md={1} xs={2} onClick={(event) => {this.stampSelected('\u2460');}} className={cellStyle} >&#9314;</Col>
          <Col md={1} xs={2} onClick={(event) => {this.stampSelected('\u2461');}} className={cellStyle} >&#9315;</Col>
          <Col md={1} xs={2} onClick={(event) => {this.stampSelected('\u2462');}} className={cellStyle} >&#9316;</Col>
          <Col md={1} xs={2} onClick={(event) => {this.stampSelected('\u2463');}} className={cellStyle} >&#9317;</Col>
          <Col md={1} xs={2} onClick={(event) => {this.stampSelected('\u2464');}} className={cellStyle} >&#9318;</Col>
          <Col md={1} xs={2} onClick={(event) => {this.stampSelected('\u2465');}} className={cellStyle} >&#9319;</Col>
        </Row>
        <Row>
        <Col md={1} xs={2}><br/></Col>
        </Row>
        <Row>
          <Col md={1} xs={2} onClick={(event) => {this.stampSelected('\u2466');}} className={cellStyle} >&#9320;</Col>
          <Col md={1} xs={2} onClick={(event) => {this.stampSelected('\u24EA');}} className={cellStyle} >&#9450;</Col>
        </Row>
      </Grid>
    </div>
    );
  }
});


module.exports = connect((state) => {
  return {
    overlay: state.overlay,
    map: state.map,
    currentUser: state.currentUser,
    stamp: state.stamp
  }
})(Numbers);



// WEBPACK FOOTER //
// ./src/app/components/tools/stamps/numbers.js